import React, {useEffect, useState} from "react";
import {base, languages_url, spheres_url, statuses_url} from "../../../../api";
import axios from "axios";
export default function EducationAndWork(props) {
	const [languageTitles, setLanguageTitles] = useState([]);
	const [sphereTitles, setSphereTitles] = useState([]);
	const [statusTitles, setStatusTitles] = useState([]);

	useEffect(() => {
		if (props?.data?.languages?.length > 0) {
			axios.get(base + languages_url).then(res => {
				const titles = res.data
					.filter(lang => props.data.languages.includes(lang.id))
					.map(lang => lang.title_am);
				setLanguageTitles(titles);
			});
		}

		if (props?.data?.sphere?.length > 0) {
			axios.get(base + spheres_url).then(res => {
				const titles = res.data.filter(s => props.data.sphere.includes(s.id)).map(s => s.title_am);
				setSphereTitles(titles);
			});
		}

		if (props?.data?.statuses?.length > 0) {
			axios.get(base + statuses_url).then(res => {
				const titles = res.data
					.filter(s => props.data.statuses.includes(s.id))
					.map(s => s.title_am);
				setStatusTitles(titles);
			});
		}
	}, [props?.data?.languages, props?.data?.sphere, props?.data?.statuses]);

	return (
		<div>
			<div className="card w-100 b-radius b-shadow mb-4 my-3">
				<div className="card-body">
					<div className="fs-4 mb-3">Work And Education details</div>
					<div className="d-flex justify-content-between align-items-center mb-3">
						<span>Languages</span>
						<span>{languageTitles.join(", ")}</span>
					</div>
					<div className="d-flex justify-content-between align-items-center mb-3">
						<span>Spheres</span>
						<span>{sphereTitles.join(", ")}</span>
					</div>
					<div className="d-flex justify-content-between align-items-center mb-3">
						<span>Statuses</span>
						<span>{statusTitles.join(", ")}</span>
					</div>
					<div className="d-flex justify-content-between align-items-center mb-3">
						<span>Work Experience</span>
						<span>
							{props?.data?.work_experience
								? new Date().getFullYear() - new Date(props.data.work_experience).getFullYear()
								: "0"}{" "}
							years
						</span>
					</div>
					<div className="d-flex justify-content-between align-items-center mb-3">
						<span>international_qualification</span>
						<span>{props?.data?.international_qualification ? "yes" : "no"} </span>
					</div>
					<div className="d-flex justify-content-between align-items-center mb-3">
						<span>local_qualification</span>
						<span>{props?.data?.local_qualification ? "yes" : "no"} </span>
					</div>
				</div>
			</div>
		</div>
	);
}
